import React, { FC, useEffect, useState } from 'react';
import { observer } from 'mobx-react-lite';
import { isStateTreeNode, onSnapshot } from 'mobx-state-tree';
import Container from 'react-bootstrap/Container';
import Navbar from 'react-bootstrap/Navbar';
import { ICategory } from '../../../model/category/Category';
import { CategoryButtons } from './CategoryButtons';
import { CategoryHighlights } from './CategoryHighlights';
import { CategoryMainInfo } from './CategoryMainInfo';
import { useCategoryController } from '../../../controllers/useCategoryController';
import {
  ContentBox,
  ContentBoxBody,
  ContentBoxHeader,
  ContentBoxNavBar
} from '../../components/content-box/ContentBox';
import { Badge } from 'react-bootstrap';
import { usePrompt } from '@yakoffice/shared-components';
import { usePageTitle } from '../pageTitleContext/PageTitleContext';


interface PropsType {
  category: ICategory;
}

export const Category: FC<PropsType> = observer((props) => {

  const controller = useCategoryController({ category: props.category });
  const [preventRender, setPreventRender] = useState(false);
  const [edited, setEdited] = usePrompt('You have unsaved changes. Are you sure you want to leave?', false);
  const { setPageTitle } = usePageTitle();

  useEffect(() => {
    const title = props.category.isNewCategory() ? newCategoryText() : props.category.name;
    setPageTitle([title, 'Categories']);
  }, [props.category]);

  if (isStateTreeNode(props.category))
    onSnapshot(props.category, () => {
      setEdited(true);
    });

  const newCategoryText = () => {
    if (props.category.parent?.id)
      return 'New Sub Category';
    else
      return 'New Category';
  };

  return preventRender ? <div /> : (
    <div id="category">
      <ContentBox>
        <ContentBoxHeader>
          <ContentBoxNavBar bg="" variant="dark" expand="lg" className={`${props.category.status}`}>
            <Container fluid>
              <Navbar.Brand>
                {props.category.isNewCategory() ? newCategoryText() : props.category.name}
              </Navbar.Brand>
              {!props.category.isNewCategory() &&
                <Badge pill bg="secondary" className="">version {props.category.versionIdCur}</Badge>
              }
              <Navbar.Toggle />
              <Navbar.Collapse id="categoryNav" className="justify-content-end">
                <CategoryButtons category={props.category}
                                 categoryEdited={edited}
                                 handleArchiveCategory={() => controller.handleArchiveCategory(() => {
                                   setEdited(false);
                                   setPreventRender(true);
                                 })}
                                 handleUnarchiveCategory={() => controller.handleUnarchiveCategory(() => {
                                   setEdited(false);
                                   setPreventRender(true);
                                 })}
                                 handleSaveCategory={() => controller.handleSaveCategory(() => {
                                   setEdited(false);
                                   setPreventRender(true);
                                 })}
                                 handleDeleteCategory={() => controller.handleDeleteCategory(() => {
                                   setEdited(false);
                                   setPreventRender(true);
                                 })} />
              </Navbar.Collapse>
            </Container>
          </ContentBoxNavBar>
        </ContentBoxHeader>
        <ContentBoxBody>

          <CategoryMainInfo category={props.category} />
          {!props.category.isNewCategory() && <CategoryHighlights category={props.category} />}
        </ContentBoxBody>
      </ContentBox>
    </div>
  );
});
